// This component is now split into:
// - GraphControls (for sidebar) - see graph-controls.tsx
// - GraphVisualization (for main window) - see graph-visualization.tsx
// This file is kept for backwards compatibility but shows controls in sidebar

import { useMemo } from 'react';
import { GraphControls } from './graph-controls';
import { useGraphState } from './use-graph-state';

export function GraphView() {
  const graphState = useGraphState();
  
  // Extract unique projects from nodes for filter dropdown
  const availableProjects = useMemo(() => {
    const projectMap = new Map<string, string>();
    graphState.graphData.nodes.forEach(node => {
      if (node.projectId && node.projectName && !projectMap.has(node.projectId)) {
        projectMap.set(node.projectId, node.projectName);
      }
    });
    return Array.from(projectMap.entries()).map(([id, name]) => ({ id, name }));
  }, [graphState.graphData.nodes]);
  
  return (
    <GraphControls
      showManualLinks={graphState.showManualLinks}
      showAIConnections={graphState.showAIConnections}
      showFlowJobs={graphState.showFlowJobs}
      similarityThreshold={graphState.similarityThreshold}
      onToggleManualLinks={graphState.setShowManualLinks}
      onToggleAIConnections={graphState.setShowAIConnections}
      onToggleFlowJobs={graphState.setShowFlowJobs}
      onSimilarityThresholdChange={graphState.setSimilarityThreshold}
      groupBy={graphState.groupBy}
      onGroupByChange={graphState.setGroupBy}
      filterProject={graphState.filterProject}
      onFilterProjectChange={graphState.setFilterProject}
      availableProjects={availableProjects}
      stats={graphState.graphData.stats}
    />
  );
}
